import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchCarrierInfo = createProvider(api.fetchCarrierInfo).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Fetch carrier info aborted');
  } else {
    console.error('Fetch carrier info was failed:', error);
  }
  throw error;
});
